import { IFromPrice, IPrice, ISFCCPrice } from '@gn-audio/core/api/pricing/models';
import { AvailabilityState } from '@gn-audio/core/common/enums';
import { Component, Inject, Input, OnInit, Output } from 'angular-ts-decorators';
import { TranslationKey, TranslationService } from 'src/Foundation/Translation/platform';
import { ScrollTargetSelector } from '../models';
import { assertNever, scrollToTarget } from '../utils';
import { BuyButtonService } from './buy-button.service';

import template from './buy-button.component.html';

const radix = 10;

@Component({
  selector: 'buyButton',
  template,
})
export class BuyButtonComponent implements OnInit {
  public static $inject: ReadonlyArray<string> = [];
  public buttonState?: AvailabilityState;

  @Input() public pId?: string;
  @Input() public pType?: string;

  @Output() public onPriceLoaded?: (price: IFromPrice | IPrice | ISFCCPrice) => void;

  constructor(
    @Inject('translation') private readonly translationService: TranslationService,
    @Inject('buyButtonService') private readonly buyButtonService: BuyButtonService,
  ) {
  }

  public ngOnInit(): void {
    this.buyButtonService.getButtonState(parseInt(this.pId, radix))
      .then((state: AvailabilityState) => { this.buttonState = state; });
  }

  public get isButtonVisible(): boolean {
    return this.buttonState !== undefined;
  }

  public onButtonClick(): void {
    switch (this.buttonState) {
      case AvailabilityState.Add:
      case AvailabilityState.BackOrder:
      case AvailabilityState.PreOrder:
      case AvailabilityState.WhereToBuy:
        scrollToTarget(document.querySelector(ScrollTargetSelector.Customizer));
        break;
      case AvailabilityState.ComingSoon:
        scrollToTarget(document.querySelector(ScrollTargetSelector.Form));
        break;
      default:
        assertNever(this.buttonState);
    }
  }

  public get buttonText(): string {
    switch (this.buttonState) {
      case AvailabilityState.WhereToBuy:
        return this.translationService.getSystem(TranslationKey.WhereToBuy);
      case AvailabilityState.Add:
      case AvailabilityState.BackOrder:
        return this.translationService.getSystem(TranslationKey.BuyNow);
      case AvailabilityState.PreOrder:
        return this.translationService.getSystem(TranslationKey.PreOrder);
      case AvailabilityState.ComingSoon:
        return this.translationService.getSystem(TranslationKey.KeepMeUpdated);
      default:
        return '';
    }
  }
}
